//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LazyLoad from './lazy-load';
import { isMobile } from '@/utils/constants.js'

export default {
  components: {
    LazyLoad
  },
  props: {
    iframeOptions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      coverZIndex: 1,
      rateClass: '',
      maxShowClass: '',
      biggest: false,
      previewInitTime: new Date(),
      isPhone: isMobile(),
    };
  },
  computed: {
    fileUrl: {
      get() {
        return this.iframeOptions.fileUrl?.indexOf('https') !== -1 ? this.iframeOptions.fileUrl : '';
      },
      set() {
        this.$nextTick(() => {
          this.resourceWindow = document.getElementById('mainIframe').contentWindow;
        });
      },
    },
    coverUrl: {
      get() {
        return this.iframeOptions.coverUrl?.indexOf('https') !== -1 ? this.iframeOptions.coverUrl : '';
      },
    },
    width: {
      get() {
        return this.iframeOptions.width ? this.iframeOptions.width : '960px';
      },
    },
    height: {
      get() {
        return this.iframeOptions.height ? this.iframeOptions.height : '540px';
      },
    },
    border() {
      return this.iframeOptions.border;
    },
    showZoomButton: {
      get() {
        return this.iframeOptions.showZoomButton ? this.iframeOptions.showZoomButton : false;
      },
    },
    showProgressBar: {
      get() {
        return this.iframeOptions.showProgressBar === false ? this.iframeOptions.showProgressBar : true;
      },
    },
    autoEnlarge: {
      get() {
        return this.iframeOptions.autoEnlarge === false ? this.iframeOptions.autoEnlarge : true;
      },
    },
    styleObj() {
      const obj = {
        width: this.width,
        height: this.height,
      };
      if (this.border) {
        obj.borderRadius = this.border;
      }
      return obj;
    },
  },
  mounted() {
    this.previewInitTime = new Date().getTime();
    const colorMessage = {
      light: 'mgThemeLight',
      dark: 'mgThemeDark',
    };
    this.$root.$on('colorMode', (data) => {
      this.emitResourceEvent(colorMessage[data]);
    });
    this.$nextTick(() => {
      setTimeout(() => {
        this.updateProgressBar(95);
      }, 1000);
    });
    window.addEventListener('message', this.onResourceEvent);
    document.addEventListener('keyup', this.escape, true);
    setTimeout(() => {}, 5000);
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.escape);
    window.removeEventListener('click', this.clickOut);
    window.removeEventListener('message', this.onResourceEvent);
  },
  methods: {
    onResourceLoad() {
      this.resourceWindow = document.getElementById('mainIframe').contentWindow;
    },
    escape(e) {
      console.log('---', e);
      if (e.code === 'Escape' && this.biggest) {
        this.shrink();
      }
    },
    clickOut() {
      if (this.biggest) this.shrink('hand-shink');
    },
    enlarge() {
      this.emitResourceEvent('mgPreviewFull');
      this.biggest = true;
      this.maxShowClass = 'biggest-show';
      window.addEventListener('click', this.clickOut);
      this.forbidHTMLScroll(true)
      
    },
    forbidHTMLScroll(isForbid){
      const htmlStyle = document.getElementsByTagName('html')[0].style
      htmlStyle.overflow = isForbid?'hidden':'auto'
    },
    shrink(type) {
      this.emitResourceEvent('mgPreviewLite');
      this.biggest = false;
      this.maxShowClass = type === 'hand-shink' ? 'oprate-shink' : 'middle-show';
      this.coverZIndex = -1;
      window.removeEventListener('click', this.clickOut);
      this.forbidHTMLScroll(false)
    },
    emitResourceEvent(data) {
      if (!this.resourceWindow) {
        setTimeout(() => {
          if (document.getElementById('mainIframe')) {
            this.resourceWindow = document.getElementById('mainIframe').contentWindow;
          }
          this.emitResourceEvent(data);
        }, 500);
        return;
      }
      this.resourceWindow.postMessage(String(data), '*');
    },
    onResourceEvent(type) {
      const mgCanvasReadyTime = new Date().getTime();
      const iframeFinishedTime = mgCanvasReadyTime - this.previewInitTime;
      const mgCanvasEvent = typeof type.data === 'string' ? type.data : type.data.action;
      const layerSize = typeof type.data === 'string' ? '' : type.data.value;
      switch (mgCanvasEvent) {
        case 'mgCanvasInit':
          break;
        case 'mgFileLoaded':
          break;
        case 'mgCanvasReady':
          this.updateProgressBar(100);
          this.$emit('handlePageTimeLog', mgCanvasReadyTime, iframeFinishedTime, layerSize);
          break;
        default:
          break;
      }
    },
    updateProgressBar(rateNum = 0) {
      this.rateClass = `rate${rateNum}`;
      if (rateNum === 100) {
        setTimeout(() => {
          if (this.autoEnlarge) {
            this.shrink();
          } else {
            this.coverZIndex = -1;
          }
          this.$emit('hideBorder');
        }, 300);
      }
    },
  },
};
